/*
 * @Description:
 * @Author: hejiajun
 * @Date: 2026-02-02 10:13:17
 * @LastEditors: hejiajun
 * @LastEditTime: 2026-03-14 00:00:00
 */

/**
 * 创建并追加一个 import map 脚本到文档头部
 * @param {string} name - 脚本类型，例如 'systemjs-importmap'
 * @param {Object} importmapConfig - import map 配置对象
 * @returns {HTMLScriptElement} 创建的脚本元素
 * @throws {TypeError} 如果 name 不是字符串或 importmapConfig 不是对象
 */
const createImportMapScript = (name, importmapConfig) => {
  // 参数验证
  if (typeof name !== "string" || !name.trim()) {
    throw new TypeError('Parameter "name" must be a non-empty string');
  }

  if (typeof importmapConfig !== "object" || importmapConfig === null) {
    throw new TypeError('Parameter "importmapConfig" must be a valid object');
  }

  try {
    const realScript = document.createElement("script");
    realScript.type = name;
    realScript.textContent = JSON.stringify(importmapConfig);
    document.head.appendChild(realScript);

    return realScript;
  } catch (error) {
    console.error("创建 import map 脚本时出错:", error);
    throw error;
  }
};

export { createImportMapScript };
